import styled from "styled-components";

export const StyledInputWrapper = styled.div`
  span.error {
    margin-bottom: 16px;
  }
`;
